import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../../styled-components/dark';
import { MatchStatuses, type MatchStatus } from '../../../../types/match';

const STATS_COLOR: Partial<Record<MatchStatus | 'default', { backgroundColor: string; color: string }>> = {
  [MatchStatuses.LIVE]: {
    backgroundColor: theme.LineUpPlayerStats.default.backgroundColor,
    color: theme.LineUpPlayerStats.default.color,
  },
  [MatchStatuses.ENDED]: {
    backgroundColor: theme.LineUpPlayerStats.ended.backgroundColor,
    color: theme.LineUpPlayerStats.ended.color,
  },
  default: {
    backgroundColor: theme.LineUpPlayerStats.default.backgroundColor,
    color: theme.LineUpPlayerStats.default.color,
  },
};

type WrapperType = {
  $status: MatchStatus;
};

const Wrapper = styled.div<WrapperType>`
  position: absolute;
  min-width: 2.2em;
  height: 2em;
  top: 0;
  right: 0;
  border-radius: 0 1.5em 0 0.45em;
  padding: 0 0.3em 0 0.15em;

  ${({ $status }) => {
    const style = STATS_COLOR[$status] ?? STATS_COLOR.default;

    return css`
      background-color: ${style?.backgroundColor};
    `;
  }}

  display: flex;
  align-items: center;
  justify-content: center;
`;

type LabelType = {
  $status: MatchStatus;
};

const Label = styled.div<LabelType>`
  font-size: 1.4em;
  font-weight: bold;

  ${({ $status }) => {
    const style = STATS_COLOR[$status] ?? STATS_COLOR.default;

    return css`
      color: ${style?.color};
    `;
  }}
`;

type PropsType = {
  matchStatus?: MatchStatus;
  value?: number;
};

const LineUpPlayerStats = ({ matchStatus = MatchStatuses.PREMATCH, value }: PropsType) => {
  return (
    <Wrapper $status={matchStatus}>
      <Label $status={matchStatus}>{value}</Label>
    </Wrapper>
  );
};

export default LineUpPlayerStats;
